module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEkSURBVEhL7ZGxTcRAEEWtA+muCQIaoAlCOqANCriUE7pqyGmCnICMhBQiw3+j55MthM82CRI8abQ7f/7MWp7mn44PMT2O/kn0/dU8Bf2T6PureQr6J9H3V/Nc2rbd2d/n1nKhtuyB9J3mkbvEi8GDJ5Z/Rn3WCNqW45xv0faLyf++8mO/QE3bMjJjkyFPDnvmhO5ubaN9PhmwdRBccgfuCN632ueRxvPEm0P2aNzB+p47Hrxos0jTvQMeE2s0crC+pkaOF20yaajF5nxPXCgPHgBqeNDoUR4n3v5ib5QLNDAt8KDZc3zhMXaLfcixUi7QwbRIutJLz/jCY6jFJl4TZ8oHGAKmB/DaM77wFLvFXisNqOnBdAA91JihNJ+aHkz/BE3zCZRHgZB1HcEjAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-land-surveying/light/24.png
// module id = 2218
// module chunks = 2